import React, { FunctionComponent } from "react";
import { Box, Text } from "@familyzone/component-library";

import IconSparkles from "assets/sparkles.svg?url";

export const NewBadge: FunctionComponent = () => {
	return (
		<Box display="flex" alignItems="center" textColor="#2B0086" bg="#F3DBFF" borderRadius={4} px={6} py={3} ml={10}>
			<Text fontSize="xs" fontWeight={700} mr={3}>
				NEW
			</Text>
			<img src={IconSparkles} className="ctxbar-badge-icon" alt="" />
		</Box>
	);
};
